import React from 'react';
import { Container, Card, Row, Col} from 'react-bootstrap';
import spec1 from "../../../images/specialist/img-spec1.png";
import spec2 from "../../../images/specialist/img-spec2.png";
import spec3 from "../../../images/specialist/img-spec3.jpg";
import spec4 from "../../../images/specialist/img-spec4.jpg";
import spec5 from "../../../images/specialist/img-spec5.jpg";
import spec6 from "../../../images/specialist/img-spec6.jpg";
import { useTranslation } from 'react-i18next';

const Specialist = () => {
  const { t } = useTranslation();
  const people = t("landing.specialist.people", { returnObjects: true });

  const images = [spec1, spec2, spec3, spec4, spec5, spec6];

  return (
    <section id="specialist" className="py-5">
      <Container style={{ paddingTop: '50px' }}>
        <h2
          className="text-center mb-5"
          style={{
            backgroundColor: '#90EE90',
            color: '#fff',
            border: '1px solid #CECECE',
            paddingTop: '35px',
            paddingBottom: '25px',
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)'
          }}
        >
          {t("landing.specialist.title")}
        </h2>
        <Row>
          {people.map((person, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="card-hover">
                <Card.Img variant="top" src={images[index]} alt={person.name} />
                <Card.Body>
                  <Card.Title>{person.name}</Card.Title>
                  <Card.Subtitle
                    style={{
                      fontFamily: 'Courier, monospace',
                      fontSize: '16px'
                    }}
                  >
                    {person.speciality}
                  </Card.Subtitle>
                  <br />
                  <Card.Text className="text-justify">
                    {person.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Specialist;